import { HttpContextToken } from "@angular/common/http";

/** Opt-out for requests that show their own progress or stay open on purpose (a long-poll, a stream). */
export const SKIP_LOADER = new HttpContextToken<boolean>(() => false);
